<template>
   <svg width="14" height="7.999958" viewBox="0 0 14 7.999958" fill="none" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
      <path d="M 13,6.999958 7.0000015,0.99995828 1.0000002,6.999958" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /> 
   </svg>
</template>